export default `#define F d=max(d,(1.2-length(sin(p*s)))/s);p+=s*=1.3
  float l=.1,d=l,s,i;
  d=0.;
  s=1.;
  F;
  F;
  l+=F;
  F*5.;
  F;
  #undef F
  return d;
}`